import { UploadCloud } from 'lucide-react';
import { Link } from 'react-router';

import { useUsuario } from '@/lib/auth/contexto';
import { podeEmAlguma } from '@/lib/auth/permissoes';
import { useEscopoEmpresas } from '@/lib/escopo';
import { CabecalhoPagina } from '@/ui/patterns/cabecalho-pagina';
import { estiloBotao } from '@/ui/primitives/estilos';

import { useResumoDoMes } from './api';
import { IndicadoresDoMes, PainelChaves, PainelLotes } from './paineis';
import { PainelCertificados } from './painel-certificados';
import { PainelPendencias } from './painel-pendencias';
import { PrimeirosPassos } from './primeiros-passos';

const MES = new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' });

export function PaginaInicio() {
  const usuario = useUsuario();
  const temEmpresa = usuario.vinculos.some((v) => v.permissoes.includes('documentos.ler'));
  const primeiroNome = usuario.nome.split(' ')[0] ?? usuario.nome;
  if (!temEmpresa) {
    return (
      <div className="grid gap-6">
        <CabecalhoPagina titulo={`Olá, ${primeiroNome}`} descricao="Vamos começar." />
        <PrimeirosPassos
          podeCadastrar={usuario.permissoesPlataforma.includes('plataforma.empresas.gerenciar')}
        />
      </div>
    );
  }
  return <PainelDoMes primeiroNome={primeiroNome} />;
}

function PainelDoMes({ primeiroNome }: { primeiroNome: string }) {
  const usuario = useUsuario();
  const escopo = useEscopoEmpresas();
  // Painel só aparece (e só consulta) para quem pode usar a rota dele — nada de 403 no console.
  const veChaves = podeEmAlguma(usuario, 'chaves.gerenciar');
  const veCertificados = podeEmAlguma(usuario, 'empresa.cadastro.ler');
  const resumo = useResumoDoMes(escopo);

  return (
    <div className="grid gap-6">
      <CabecalhoPagina
        titulo={`Olá, ${primeiroNome}`}
        descricao={`Notas de ${MES.format(new Date())} nas empresas do seu escopo.`}
        acoes={
          <Link to="/importacao" className={estiloBotao({ variante: 'primario' })}>
            <UploadCloud aria-hidden />
            Importar notas
          </Link>
        }
      />
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <IndicadoresDoMes resumo={resumo.data} erro={resumo.isError} />
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <PainelPendencias empresaIds={escopo} />
        {veCertificados && <PainelCertificados empresaIds={escopo} />}
        {veChaves && <PainelChaves empresaIds={escopo} />}
        <PainelLotes />
      </div>
    </div>
  );
}
